import { Box, withStyles } from '@material-ui/core';
import { SButton, SETVIImage, SText } from '@setvi/shared/components';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { iOSMessages, useIOSCommunication } from '@setvi/shared/hooks';
import { ROUTES } from 'enumsV2';
import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

interface ErrorPageProps {
  src: string;
  title: string;
  description: string;
}

const Container = withStyles({
  root: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 30,
    '& button': {
      width: 175,
      height: 50
    }
  }
})(Box);

const TextWrapper = withStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10,
    width: '70%',
    textAlign: 'center'
  }
})(Box);

export const ErrorPage = ({ src, title, description }: ErrorPageProps) => {
  const location = useLocation();
  const { sendMessageToIOS } = useIOSCommunication();

  // Parse query parameters
  const queryParams = new URLSearchParams(location.search);
  const ipadQueryParam = queryParams.get('isIpad');

  const isIpad = useMemo(() => ipadQueryParam === 'true', [ipadQueryParam]);

  return (
    <Container>
      <SETVIImage src={src} alt="Error" />
      <TextWrapper>
        <SText noLineClamp weight="bold" size="3xl">
          {title}
        </SText>
        <SText noLineClamp fontColor="#777E90">
          {description}
        </SText>
      </TextWrapper>
      <SButton
        startIcon={<ArrowBackIcon />}
        onClick={() => {
          if (!isIpad) {
            window.location.href = ROUTES.HOME;
            return;
          }

          sendMessageToIOS(iOSMessages.Close);
          window?.location?.reload();
        }}>
        {isIpad ? 'Refresh' : 'Go to homepage'}
      </SButton>
    </Container>
  );
};
